module.exports = function (options) {
    return {
        ...options,

        // Overwrite options
        language: 'nl',

        // Add styles
        stylesSet: [
            { name: 'Normal', element: 'span', attributes: { class: '' } },

            { name: 'Heading 1', element: 'p', attributes: { class: 'h1' } },
            { name: 'Heading 2', element: 'p', attributes: { class: 'h2' } },
            { name: 'Heading 3', element: 'p', attributes: { class: 'h3' } },
            { name: 'Heading 4', element: 'p', attributes: { class: 'h4' } },
            { name: 'Heading 5', element: 'p', attributes: { class: 'h5' } },

            { name: 'Dunne tekst', element: 'p', attributes: { class: 'font-light' } },

            { name: 'Primaire knop', element: 'a', attributes: { class: 'btn-primary' } },
            { name: 'Secundaire knop', element: 'a', attributes: { class: 'btn-secondary' } },
            { name: 'Tertiaire knop', element: 'a', attributes: { class: 'btn-tertiary' } },
            { name: 'Witte knop', element: 'a', attributes: { class: 'btn-white' } },
            { name: 'Grijs-omlijnde knop', element: 'a', attributes: { class: 'btn-gray-outline' } },
        ],
    };
};
